<template lang="">
    <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="90%"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{titulo}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>

            <table style="border-spacing: 10px;">
                <tbody>
                  <tr >
                    <td colspan="4" style="text-align: center;">
                      Actual: {{valor_original}}
                    </td>
                  </tr>
                  <tr >
                    <td colspan="4" style="text-align: center;">
                      <v-text-field v-model="valor_actual"></v-text-field>
                    </td>
                  </tr>
                    <tr>
                        <td><v-btn block @click="add('7')">7</v-btn></td>
                        <td><v-btn block @click="add('8')">8</v-btn></td>
                        <td><v-btn block @click="add('9')">9</v-btn></td>
                        <td><v-btn block @click="add('signo')">+/-</v-btn></td>
                    </tr>
                    <tr>
                        <td rowspan='1'><v-btn block @click="add('4')">4</v-btn></td>
                        <td rowspan='1'><v-btn block @click="add('5')">5</v-btn></td>
                        <td  rowspan='1'><v-btn block @click="add('6')">6</v-btn></td>
                        <td  rowspan='2' ><v-btn block @click="add('retroceso')"><=</v-btn></td>
                    </tr>
                    <tr>
                        <td rowspan='1'><v-btn block @click="add('1')">1</v-btn></td>
                        <td rowspan='1'><v-btn block @click="add('2')">2</v-btn></td>
                        <td  rowspan='1'><v-btn block @click="add('3')">3</v-btn></td>
                    </tr>
                    <tr>
                        <td ><v-btn block @click="add('0')">0</v-btn></td>
                        <td ><v-btn block @click="add('.')">.</v-btn></td>
                        <td  colspan='2'><v-btn block @click="add('clear')">CLEAR</v-btn></td>
                    </tr>
                    <tr>
                        <td  colspan='2'><v-btn block @click="add('cancel')">CANCEL</v-btn></td>
                        <td  colspan='2'><v-btn block @click="add('enter')">ENTER</v-btn></td>
                    </tr>


                </tbody>
            </table>
            <v-row class="sitio">
              <v-col cols="6">
                <p style="text-align: center;">Min: {{valor_min}}</p>
              </v-col> 
               <v-col cols="6">
                <p style="text-align: center;">Max: {{valor_max}}</p>
              </v-col>
            </v-row>
            
            <!-- <div v-if="texto_error!=''"> -->
              {{texto_error}}
            <!-- </div> -->
     

          </v-container>
         
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    dialog: true,
    valor_actual: null,
    texto_error:null
  }),

  props: {
    titulo: String,
    valor_min: [Number,String],
    valor_max: [Number,String],
    valor_original: [Number,String],
  },

  mounted() {
    this.valor_actual = this.valor_original;
  },

  methods: {
    isNumeric(input) {
      return !isNaN(input);
    },
    cancelar() {
      this.$emit("cancelar");
    },
    aceptar(){
      this.$emit("aceptar",this.valor_actual);
    },
    add(v) {
      if(this.isNumeric(v)){
        this.valor_actual += v;
      }else{
        if(v=='signo'){
          this.valor_actual*=-1;
          this.valor_actual=this.valor_actual.toString();

        }
        if(v=='retroceso'){
          this.valor_actual=this.valor_actual.slice(0, -1);
          if(this.valor_actual.charAt(this.valor_actual.length - 1)=='.'){
            this.valor_actual=this.valor_actual.slice(0, -1);
          }
        }
        if(v=='clear'){this.valor_actual=''}

        if(v=='.'){
          if(!this.valor_actual.includes('.')) this.valor_actual+='.'
        }
        if(v=='cancel')
          this.cancelar()
        
        if(v=='enter')
          if(this.isNumeric(this.valor_actual)){
            if( (parseFloat( this.valor_actual)<=parseFloat( this.valor_max) )&&
            (parseFloat( this.valor_actual)>=parseFloat( this.valor_min) )){
              this.aceptar()
              console.log("okkkkkkkkkkk")
            }
            else{
            console.log("errrorrrrrrrrrrr")
            this.texto_error='NO ESTÁ DENTRO DEL RANGO'
          }

          }else{
            console.log("errrorrrrrrrrrrr")
            this.texto_error='NO ES UN VALOR NUMÉRICO'
          }
        
      }
    
    },
  },
};
</script>
<style scoped>
.sitio {
  margin-top: 2%;
}
table {
  margin: 0 auto; /* Horizontal centering */
  width: 100%;
      height: 100%;
}
</style>